import { render, staticRenderFns } from "./SmsApplianceRemindRate.vue?vue&type=template&id=75047b0f&scoped=true"
import script from "./SmsApplianceRemindRate.vue?vue&type=script&lang=js"
export * from "./SmsApplianceRemindRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75047b0f",
  null
  
)

export default component.exports